import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { FeatureFlagsEnum } from '@models/environment.type';
import { ChatbotScriptService } from '@services/chatbot-script/chatbot-script.service';
import { FeatureFlagService } from '@services/feature-flag/feature-flag.service';

export const chatbotVisibleGuard = (
  route: ActivatedRouteSnapshot,
  router: Router,
): boolean => {
  const featureFlagService = inject(FeatureFlagService);
  const service = inject(ChatbotScriptService);
  const featureActive = featureFlagService.isFeatureActive(
    FeatureFlagsEnum.CHAT_BOT,
  );
  const pathIncluded = router.url.includes('/support/');

  const chatBotVisible = featureActive && pathIncluded;

  service.handleChatbotScript(chatBotVisible);

  return true;
};
